import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";

interface IPayment {
  paymentId: string;
}

export const useGetPayment = (bookingId: string) => {
  const { user, siteId } = useAuth();
  const [getRecords] = useLazyReadMultipleQuery();
  const [paymentId, setPaymentId] = useState<IPayment | null>(null);

  useEffect(() => {
    getPaymentId(bookingId);
    // eslint-disable-next-line
  }, [user]);

  const getPaymentId = (bookingId: string): Promise<void> => {
    return getRecords({
      userId: user?.contactId || user?.entityId,
      portalId: siteId || '',
      tableId: "slcm_paymenttransaction",
      fieldList: [
        "slcm_paymentid",
      ],
      filters: [
        {
          group: 0,
          filters: [
            { field: "edtec365_parentid", type: FieldFilterType.Const, value: bookingId }
          ]
        }
      ]
    })
      .unwrap()
      .then((data) => {
        const record = data.records[0].slcm_paymentid;

        if (record) {
          const shuttleConfig: IPayment = {
            paymentId: record
          };
          setPaymentId(shuttleConfig);
        }
      });
  };

  return { paymentId };
};
